import { useRoute } from 'vue-router'
import router from '@/router'
import { useAuthStore } from '@/stores/authStore'

export interface IUsePreventNavigation {
	routeToTweak: () => boolean
}

export function usePreventNav(): IUsePreventNavigation {
	const authStore = useAuthStore()
	const route = useRoute()

	function routeToTweak(): boolean {
		if (!authStore.isAuth()) {
			router.push('/account/signup')
		}
		else {
			router.push({ path: '/tweak', query: route.query })
		}
		return true
	}

	return { routeToTweak }
}
